import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Database, Zap, Users, Package, Map, Truck, Fuel, TrendingUp } from "lucide-react";

const MOBILE_TABS = {
  admin: [
    { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/dt-master", icon: Database, label: "DTs" },
    { to: "/shutdowns", icon: Zap, label: "Shutdowns" },
    { to: "/employees", icon: Users, label: "Employees" },
    { to: "/inventory", icon: Package, label: "Inventory" },
  ],
  technician: [
    { to: "/daily-roster", icon: LayoutDashboard, label: "Tasks" },
    { to: "/dt-master", icon: Database, label: "DTs" },
    { to: "/field-map", icon: Map, label: "Map" },
  ],
  supervisor: [
    { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/dt-master", icon: Database, label: "DTs" },
    { to: "/teams", icon: Users, label: "My Pod" },
  ],
  surveyor: [
    { to: "/feeder-assignments", icon: Database, label: "Feeders" },
    { to: "/dt-master", icon: Database, label: "Survey" },
    { to: "/field-map", icon: Map, label: "Map" },
    { to: "/my-performance", icon: TrendingUp, label: "Stats" },
  ],
  driver: [
    { to: "/vehicles", icon: Truck, label: "Vehicle" },
    { to: "/vehicles", icon: Fuel, label: "Refuel" },
    { to: "/vehicles", icon: Map, label: "Trips" },
  ],
  vehicle_incharge: [
    { to: "/vehicles", icon: Truck, label: "Fleet" },
    { to: "/employees", icon: Users, label: "Drivers" },
    { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  ],
};

export default function MobileNav() {
  const { user } = useAuth();
  const tabs = MOBILE_TABS[user?.role] || MOBILE_TABS.admin;

  return (
    <nav className="fixed bottom-0 left-0 right-0 lg:hidden bg-white border-t border-slate-200 z-30" data-testid="mobile-nav">
      <div className="flex">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.to + tab.label}
              to={tab.to}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center py-2 px-1 transition-colors ${isActive ? "text-orange-500" : "text-slate-400"}`
              }
              data-testid={`mobile-nav-${tab.label.toLowerCase()}`}
            >
              <Icon size={20} strokeWidth={1.5} />
              <span className="text-[10px] mt-0.5 font-medium">{tab.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
